module.exports = __webpack_public_path__ + "img/malla-main.99633e68.jpg";